import React from 'react';
import { Sword, Shield, Zap } from 'lucide-react';
import type { BattleMove, BattleEffect } from '../../types/battle';

interface BattleHistoryProps {
  moves: Array<{
    player: BattleMove;
    ai: BattleMove;
  }>;
  effects: Array<{
    player: BattleEffect[];
    ai: BattleEffect[];
  }>;
}

export function BattleHistory({ moves, effects }: BattleHistoryProps) {
  const getMoveIcon = (type: string) => {
    switch (type) {
      case 'attack':
        return <Sword className="w-4 h-4" />;
      case 'defend':
        return <Shield className="w-4 h-4" />;
      case 'special':
        return <Zap className="w-4 h-4" />;
      default:
        return null;
    }
  };

  return (
    <div className="bg-gray-800 rounded-lg p-4 max-h-[200px] overflow-y-auto">
      <h3 className="text-lg font-bold text-white mb-4">Battle Log</h3>
      <div className="space-y-2">
        {moves.map((move, index) => {
          const playerEffects = effects[index]?.player || [];
          const aiEffects = effects[index]?.ai || [];

          return (
            <div key={index} className="space-y-1">
              {/* Player's move */}
              <div className="flex items-center gap-2 text-cyan-400">
                {getMoveIcon(move.player.type)}
                <span className="capitalize">You used {move.player.type}</span>
                {playerEffects.map((effect, i) => (
                  <span key={i} className="text-sm text-gray-400">
                    - {effect.description}
                  </span>
                ))}
              </div>

              {/* AI's move */}
              {move.ai && (
                <div className="flex items-center gap-2 text-pink-400">
                  {getMoveIcon(move.ai.type)}
                  <span className="capitalize">Enemy used {move.ai.type}</span>
                  {aiEffects.map((effect, i) => (
                    <span key={i} className="text-sm text-gray-400">
                      - {effect.description}
                    </span>
                  ))}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}